module.exports = __webpack_public_path__ + "static/media/7030c138.jpg";